// @flow
import type Immutable from "seamless-immutable";
import createReducer from "common/reducerBase";
import { doListsSelection, doListsMultipleSelection } from "tabs/common/reducerMethods";
import FacebookRecord, { getNewList } from "../data/FacebookRecord";
import consts from "../data/consts";
import { types as ats } from "../actions";

const CTXS = consts.CONTEXTS;

export default {
	facebook: createReducer(FacebookRecord(), {

		[ats.SET_LOGIN_STATUS_SUCCESS]: (state: Object, { payload }) => state.merge({
			auth: payload.auth,
			authProgressIndicator: false,
		}),

		[ats.SET_USER_SUCCESS]: (state: Object, { payload }) => state.set("user", payload.user),

		[ats.SET_USER_LOGIN_SUCCESS]: (state: Object, { payload }) => state.set("auth", payload.auth),

		[ats.SET_USER_LOGOUT_SUCCESS]: (state: Object) => state.replace(FacebookRecord()),

		[ats.SET_PHOTOS_RETRIEVE_START]: (state: Object, { payload }) => state.set("currentContext", payload.context)
			.setIn(["lists", payload.context, "inProgress"], true),

		[ats.SET_PHOTOS_RETRIEVE_FAILED]: (state: Object, { payload }) => state.setIn(["lists", payload.context, "inProgress"], false),

		[ats.SET_PHOTOS_RETRIEVE_SUCCESS]: (state: Object, { payload }) => state.setIn(["lists", payload.context], {
			...state.lists[payload.context],
			inProgress: false,
			items: payload.items,
			cursor: payload.cursor,
		}),

		[ats.SET_FILE_SELECTION]: doListsSelection,

		[ats.SET_MULTI_FILE_SELECTION]: doListsMultipleSelection,

		[ats.SET_ALBUM_RETRIEVE_SUCCESS]: (state: Object, { payload }) => state.set("albumData", payload.album),

		[ats.CLEAR_PHOTOS_FOR_CONTEXT]: (state: Object, { payload }) => state.setIn(["lists", payload.context], {
			...getNewList(),
			inProgress: state.lists[payload.context].inProgress,
		}),

		[ats.CLEAR_IMAGE_SELECTION]: (state: Object, { payload }) => state.setIn(["lists", payload.context, "selected"], []),

		[ats.CLEAR_ALL_SELECTION]: (state: Immutable) => state.merge({
			lists: {
				[CTXS.ALBUM_PHOTOS]: { selected: [] },
				[CTXS.TAGGED_PHOTOS]: { selected: [] },
				[CTXS.UPLOADED_PHOTOS]: { selected: [] },
				[CTXS.ALBUMS]: { selected: [] },
			},
		}, { deep: true }),

	}),
};
